var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 280,
    viewBox: "0 0 281 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.097 54.6061C181.097 54.6061 151.148 92.5417 103.229 69.9134C55.3104 47.285 7.39143 108.515 48.6549 145.785C89.9184 183.055 49.539 203.535 77.5718 226.376C109.433 252.337 137.172 199.694 162.462 211.673C218.279 238.113 259.631 227.646 250.313 197.031C233.957 143.291 213.043 139.795 229.016 111.842C244.989 83.8897 209.736 25.7693 181.097 54.6061Z",
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.792 159.526L162.426 172.229L151.156 232.614L130.855 228.824L143.872 159.068L144.491 155.744L164.792 159.526Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.788 129.148L207.788 166.676C207.767 166.786 207.725 166.891 207.664 166.985C207.603 167.079 207.524 167.16 207.432 167.223C207.34 167.286 207.236 167.33 207.126 167.354C207.017 167.377 206.904 167.378 206.794 167.357L108.449 149.015L120.024 86.9531L194.704 100.882C208.239 103.406 217.229 116.058 214.788 129.148Z",
    fill: "#A2BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.03 116.553L134.084 153.79L82.4629 144.162L89.408 106.925C91.9651 93.2151 105.594 84.2558 119.849 86.9144C134.104 89.573 143.587 102.843 141.03 116.553Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.062 133.961C161.257 133.251 158.748 129.554 159.464 125.715C160.18 121.875 163.854 119.331 167.658 120.041C168.87 120.268 170.001 120.813 170.935 121.62C171.869 122.427 172.572 123.466 172.974 124.633L221.026 133.595L219.728 140.555L171.676 131.593C170.88 132.537 169.85 133.253 168.688 133.669C167.526 134.085 166.275 134.185 165.062 133.961Z",
    fill: "#418DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.316 117.238L132.549 153.518L83.9199 144.448L90.6871 108.168C93.1784 94.8098 106.085 86.0111 119.513 88.5157C132.942 91.0203 141.807 103.88 139.316 117.238Z",
    fill: "#418DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.423 130.444C168.378 130.444 169.963 128.859 169.963 126.903C169.963 124.948 168.378 123.363 166.423 123.363C164.468 123.363 162.883 124.948 162.883 126.903C162.883 128.859 164.468 130.444 166.423 130.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.58 133.569L217.335 156.327C217.317 156.425 217.261 156.512 217.178 156.568C217.096 156.625 216.995 156.646 216.897 156.628L205.739 154.547C205.72 154.543 205.703 154.532 205.691 154.516C205.68 154.499 205.676 154.479 205.68 154.46L209.98 131.405C209.983 131.386 209.994 131.369 210.011 131.358C210.027 131.347 210.047 131.342 210.066 131.346L221.521 133.482C221.54 133.486 221.557 133.497 221.568 133.513C221.58 133.53 221.584 133.55 221.58 133.569Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.013 131.429C100.483 134.886 104.276 138.994 104.276 138.994C98.4961 139.404 95.3661 136.135 94.0193 134.149C92.3542 134.63 90.6428 134.934 88.9138 135.055C77.0487 135.896 66.8346 128.15 66.0969 117.745C65.3592 107.339 74.3787 98.2295 86.2439 97.3886C98.109 96.5478 108.322 104.294 109.06 114.699C109.54 121.468 105.888 127.689 100.013 131.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.133 153.813C133.596 155.173 123.77 195.688 91.9738 189.758C57.1069 183.855 82.3269 144.15 82.3269 144.15L134.133 153.813Z",
    fill: "#A2BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.579 119.791C89.2083 119.791 90.5291 118.47 90.5291 116.841C90.5291 115.211 89.2083 113.891 87.579 113.891C85.9497 113.891 84.6289 115.211 84.6289 116.841C84.6289 118.47 85.9497 119.791 87.579 119.791Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3702 118.504C76.0093 118.504 77.3381 117.175 77.3381 115.536C77.3381 113.897 76.0093 112.568 74.3702 112.568C72.7311 112.568 71.4023 113.897 71.4023 115.536C71.4023 117.175 72.7311 118.504 74.3702 118.504Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.659 121.047C102.298 121.047 103.627 119.718 103.627 118.079C103.627 116.44 102.298 115.111 100.659 115.111C99.0202 115.111 97.6914 116.44 97.6914 118.079C97.6914 119.718 99.0202 121.047 100.659 121.047Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.791 159.526L162.425 172.229L143.871 159.068L144.49 155.744L164.791 159.526Z",
    fill: "#418DF9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.438741689993ce5601216840727e1b96.svg";
export { ForwardRef as ReactComponent };